import AsyncStorage from "@react-native-async-storage/async-storage";
import DeviceInfo from "react-native-device-info";
// import {createClient} from '@segment/analytics-react-native';
import { AsyncStorageKeys } from "./enum";
import { logEvent } from "firebase/analytics";
import { analytics } from "./firebaseConfig";

// const segmentClient = createClient({
//   writeKey: Config.SEGMENT_KEY,
//   trackAppLifecycleEvents: true,
//   debug: false,
// });

export const track = async (eventName, data, eventData = {}) => {
    // const userId = await AsyncStorage.getItem(AsyncStorageKeys.USER_ID);
    // eventData = {userId: userId || ''};
    //   let trackData = await AsyncStorage.getItem('SegentTrackData');
    //   if (trackData) {
    //     trackData = JSON.parse(trackData);
    //     segmentClient.track(eventName, {...data, ...trackData});
    //   } else {
    //     segmentClient.track(eventName, {...data});
    //   }
    // try {
    //   await analytics().logEvent(eventName, eventData);
    // } catch (error) {
    //   console.error('Firebase Analytics Error:', error);
    // }
    return;
};

export const trackV2 = async (eventName, eventData = {}) => {
    const userId = await AsyncStorage.getItem(AsyncStorageKeys.USER_ID);
    const sessionId = await AsyncStorage.getItem(AsyncStorageKeys.SESSION_ID);
    const timestamp = new Date().getTime();

    eventData = {
        ...eventData,
        userId: userId || "Guest User",
        sessionId: sessionId || "",
        timestamp: timestamp,
        user_type: userId ? "Client" : "Guest",
        deviceType: "Desktop",
    };
    try {
        // await analytics().logEvent(eventName, eventData);
        logEvent(analytics, eventName, eventData);
    } catch (error) {
        console.warn("Firebase Analytics Error:", eventData);
        console.warn("evventname", eventName);

        console.error("Firebase Analytics Error:", error);
    }
    return;
};

export const identify = async (userId, data) => {
    // let trackData = await AsyncStorage.getItem("SegentTrackData");
    // if (trackData) {
    //     trackData = JSON.parse(trackData);
    //     segmentClient.identify(userId, { ...data, ...trackData });
    // } else {
    //     segmentClient.identify(userId, { ...data });
    // }
    // return;
};

export const screen = async (screenName, data) => {
    // let trackData = await AsyncStorage.getItem("SegentTrackData");
    // if (trackData) {
    //     trackData = JSON.parse(trackData);
    //     segmentClient.screen(screenName, { ...data, ...trackData });
    // } else {
    //     segmentClient.screen(screenName, { ...data });
    // }
    // return;
};

export const setUserTrackingData = async () => {
    // let persist = await AsyncStorage.getItem("persist:root");
    // if (persist && JSON.parse(JSON.parse(persist)?.AuthReducer)?.userId) {
    //     let data = {
    //         userType: JSON.parse(JSON.parse(persist)?.AuthReducer)?.isStylistUser ? "stylist" : "client",
    //         name: JSON.parse(JSON.parse(persist)?.ProfileReducer)?.userProfile?.name,
    //         emailId: JSON.parse(JSON.parse(persist)?.ProfileReducer)?.userProfile?.emailId,
    //         gender: JSON.parse(JSON.parse(persist)?.ProfileReducer)?.userProfile?.gender,
    //         deviceModel: DeviceInfo.getModel(),
    //     };
    //     await AsyncStorage.setItem("SegentTrackData", JSON.stringify(data));
    // } else {
    //     let data = {
    //         deviceModel: DeviceInfo.getModel(),
    //     };
    //     await AsyncStorage.setItem("SegentTrackData", JSON.stringify(data));
    // }
};
